var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({attrs:{"title":"Copy to clipboard","data-test-id":"breakdance-copy-button","disabled":_vm.valueCopied},on:{"click":_vm.copyValue}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.valueCopied)?_c('Icon',{attrs:{"icon":"CheckIcon"}}):_c('Icon',{attrs:{"icon":"ClipboardIcon","size":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }